/* components/labels/Labels.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	outro_and_destroy_block,
	run_all,
	safe_not_equal,
	set_data,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out,
	update_keyed_each
} from "svelte/internal";

import { createLabel, labels } from "~/stores/labels";
import EditLabel from "./EditLabel";
import ImportDropdown from "./ImportDropdown";
import Label from "./Label";
import Step from "../Step";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[7] = list[i];
	return child_ctx;
}

// (42:4) {#if newLabel}
function create_if_block(ctx) {
	let current;
	const editlabel = new EditLabel({ props: { label: /*emptyLabel*/ ctx[2] } });
	editlabel.$on("save", /*handleCreateLabel*/ ctx[3]);
	editlabel.$on("cancel", /*cancel_handler*/ ctx[6]);

	return {
		c() {
			create_component(editlabel.$$.fragment);
		},
		m(target, anchor) {
			mount_component(editlabel, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(editlabel.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(editlabel.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(editlabel, detaching);
		}
	};
}

// (45:4) {#each $labels as label (label.id)}
function create_each_block(key_1, ctx) {
	let first;
	let current;
	const label = new Label({ props: { label: /*label*/ ctx[7] } });

	return {
		key: key_1,
		first: null,
		c() {
			first = empty();
			create_component(label.$$.fragment);
			this.first = first;
		},
		m(target, anchor) {
			insert(target, first, anchor);
			mount_component(label, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const label_changes = {};
			if (dirty & /*$labels*/ 2) label_changes.label = /*label*/ ctx[7];
			label.$set(label_changes);
		},
		i(local) {
			if (current) return;
			transition_in(label.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(label.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(first);
			destroy_component(label, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div0;
	let t0;
	let t1;
	let div3;
	let div1;
	let h3;
	let t2_value = /*$labels*/ ctx[1].length + "";
	let t2;
	let t3;
	let t4;
	let button;
	let t6;
	let div2;
	let t7;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let current;
	let dispose;

	const step = new Step({
			props: {
				text: "Declare your repository's labels:"
			}
		});

	const importdropdown = new ImportDropdown({});
	let if_block = /*newLabel*/ ctx[0] && create_if_block(ctx);
	let each_value = /*$labels*/ ctx[1];
	const get_key = ctx => /*label*/ ctx[7].id;

	for (let i = 0; i < each_value.length; i += 1) {
		let child_ctx = get_each_context(ctx, each_value, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
	}

	return {
		c() {
			div0 = element("div");
			create_component(step.$$.fragment);
			t0 = space();
			create_component(importdropdown.$$.fragment);
			t1 = space();
			div3 = element("div");
			div1 = element("div");
			h3 = element("h3");
			t2 = text(t2_value);
			t3 = text(" labels");
			t4 = space();
			button = element("button");
			button.textContent = "New Label";
			t6 = space();
			div2 = element("div");
			if (if_block) if_block.c();
			t7 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(div0, "class", "d-flex flex-justify-between flex-items-baseline mb-1");
			attr(h3, "class", "Box-title f5");
			attr(button, "class", "btn btn-sm");
			attr(button, "type", "button");
			toggle_class(button, "btn-primary", !/*newLabel*/ ctx[0]);
			toggle_class(button, "btn-outline", /*newLabel*/ ctx[0]);
			attr(div1, "class", "Box-header d-flex p-3 flex-justify-between flex-items-baseline");
			attr(div2, "role", "group");
			attr(div3, "class", "Box");
		},
		m(target, anchor, remount) {
			insert(target, div0, anchor);
			mount_component(step, div0, null);
			append(div0, t0);
			mount_component(importdropdown, div0, null);
			insert(target, t1, anchor);
			insert(target, div3, anchor);
			append(div3, div1);
			append(div1, h3);
			append(h3, t2);
			append(h3, t3);
			append(div1, t4);
			append(div1, button);
			append(div3, t6);
			append(div3, div2);
			if (if_block) if_block.m(div2, null);
			append(div2, t7);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div2, null);
			}

			current = true;
			if (remount) run_all(dispose);

			dispose = [
				listen(h3, "click", /*click_handler*/ ctx[4]),
				listen(button, "click", /*click_handler_1*/ ctx[5])
			];
		},
		p(ctx, [dirty]) {
			if ((!current || dirty & /*$labels*/ 2) && t2_value !== (t2_value = /*$labels*/ ctx[1].length + "")) set_data(t2, t2_value);

			if (dirty & /*newLabel*/ 1) {
				toggle_class(button, "btn-primary", !/*newLabel*/ ctx[0]);
			}

			if (dirty & /*newLabel*/ 1) {
				toggle_class(button, "btn-outline", /*newLabel*/ ctx[0]);
			}

			if (/*newLabel*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);
					transition_in(if_block, 1);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(div2, t7);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			if (dirty & /*$labels*/ 2) {
				const each_value = /*$labels*/ ctx[1];
				group_outros();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div2, outro_and_destroy_block, create_each_block, null, get_each_context);
				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(step.$$.fragment, local);
			transition_in(importdropdown.$$.fragment, local);
			transition_in(if_block);

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			transition_out(step.$$.fragment, local);
			transition_out(importdropdown.$$.fragment, local);
			transition_out(if_block);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(div0);
			destroy_component(step);
			destroy_component(importdropdown);
			if (detaching) detach(t1);
			if (detaching) detach(div3);
			if (if_block) if_block.d();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}

			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $labels;
	component_subscribe($$self, labels, $$value => $$invalidate(1, $labels = $$value));
	let newLabel = false;

	const emptyLabel = {
		id: "",
		name: "",
		description: "",
		colour: "#ffffff"
	};

	const handleCreateLabel = event => {
		createLabel(event.detail);
		$$invalidate(0, newLabel = false);
	};

	const click_handler = () => console.log($labels);
	const click_handler_1 = () => $$invalidate(0, newLabel = !newLabel);
	const cancel_handler = () => $$invalidate(0, newLabel = false);

	return [
		newLabel,
		$labels,
		emptyLabel,
		handleCreateLabel,
		click_handler,
		click_handler_1,
		cancel_handler
	];
}

class Labels extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Labels;